module.exports = __webpack_public_path__ + "static/media/loading-spinner.3121ce3b.gif";